/* eslint-disable import/prefer-default-export */
export const getUserName = state => state.name



// WEBPACK FOOTER //
// ./src/vuex/modules/users/getters.js